import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
  color: 'rgb(19, 206, 102)',
  failedColor: 'rgb(255, 73, 73)',
  height: '4px',
  transition: { speed: '0.4s', opacity: '0.6s', termination: 300 }
})
